/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 팀 수정 모달 콘텐츠
 * 버전 : 1.0
 * 파일명 : ModalContentModifyTeam.tsx
 * 작성자 : 강동형
 * 작성일 : 2026-01-19
 * ================================================================
 * 수정일 : 2026-02-05, 담당지역 세로 스크롤 추가
 * ================================================================ */

import styled from 'styled-components'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import { useAdTeamStore } from 'src/stores/AdTeamStore'
import RegionSelectorAdTeam from './RegionSelectorAdTeam'
import ModalSelectManager from './ModalSelectManager'
import ModalCreateTeamTable from './ModalCreateTeamTable'
import { Divider } from '@mui/material'
import { NextButton } from '../common/CommonStyled'
import AddIcon from '@mui/icons-material/Add';
import ExtraModalAddTeamMember from './ExtraModalAddTeamMember'
import { useExtraModalStore } from 'src/stores/ModalStore'


const PageWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 24px;

    position: relative;
    margin-top: 24px;
    overflow-y: auto;
    max-height: 80vh;
`
const LabelWarpper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  width: 612px;
  position:relative;
`

const LabelSpan = styled.div`
  font-size: 18px;
  font-weight: 600;
  width: 100px;
`

const ElementWrapper = styled.div`
  flex: 1;
  overflow: hidden;
  overflow-y: auto;
`
const LeftHeaderButtonWrapper = styled.div`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    line-height: normal;
`

const ModalContentModifyTeam = () => {
  const extraModalsetField = useExtraModalStore((state)=>state.setField)
  const setField = useAdTeamStore((state)=>state.setField)
  const team_name = useAdTeamStore((state)=>state.team_name)
  const memberList = useAdTeamStore((state)=>state.memberList)

  const onClickAddTeam = ()=>{
    extraModalsetField('content',<ExtraModalAddTeamMember/>)
    extraModalsetField('width','812px')
    extraModalsetField('padding','30px')
    extraModalsetField('open',true)
  }

  return (
    <PageWrapper>
      <LabelWarpper>
        <LabelSpan><span style={{color:'#09A7D6'}}>*</span> 팀명</LabelSpan>
        <ElementWrapper>
          <InputBoxOnChange value={team_name} onChange={(e)=>setField('team_name',e.target.value)} height='40px' maxLength={10}/>
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper style={{alignItems:'stretch', minHeight:'40px'}}>
        <LabelSpan style={{display:'flex',flexDirection:'column',justifyContent:'center', height:'100%'}}>
          담당지역
        </LabelSpan>
        <ElementWrapper>
          <RegionSelectorAdTeam/>
        </ElementWrapper>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>팀장</LabelSpan>
        <ModalSelectManager/>
      </LabelWarpper>
      <LabelWarpper>
        <LabelSpan>인원</LabelSpan>
        <span>{memberList.length}명</span>
      </LabelWarpper>
      <Divider sx={{width:'100%', borderColor:'#D1D1D1'}}/>
      <div style={{position:'relative', marginLeft:'auto', height:'44px', marginBottom:'-5px'}}>
        <LeftHeaderButtonWrapper>
          <NextButton style={{width:'112px',maxHeight:'44px', fontSize:'18px', fontWeight:500, gap:'8px'}} onClick={onClickAddTeam}>
              <AddIcon/> 팀 수정
          </NextButton>
        </LeftHeaderButtonWrapper>
      </div>
      <ModalCreateTeamTable/>
    </PageWrapper>
  )
}

export default ModalContentModifyTeam